import { Link } from 'react-router-dom';
import './shop.css';

export const fmtPrice = (v) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(v || 0);

export default function ShopLayout({ children, embedded = false }) {
  if (embedded) {
    return (
      <div className="ws-shop ws-shop--embedded" style={{ minHeight: 'auto', borderRadius: 12, border: '1px solid #EDE8E1' }} data-testid="shop-layout-embedded">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 24px', borderBottom: '1px solid #EDE8E1' }}>
          <span className="ws-wordmark" style={{ fontSize: 22 }}><b>wh<em>ee</em>ls</b><span>sport.</span></span>
          <span className="ws-muted" style={{ fontSize: 12, letterSpacing: 2, textTransform: 'uppercase' }}>Vista cliente · Tienda Online</span>
          <a href="/tienda" target="_blank" rel="noreferrer" className="ws-btn" style={{ padding: '8px 16px', fontSize: 12 }} data-testid="shop-open-public-site">Abrir web pública</a>
        </div>
        <main className="ws-container" style={{ paddingTop: 32, paddingBottom: 40 }}>{children}</main>
      </div>
    );
  }
  return (
    <div className="ws-shop" data-testid="shop-layout">
      <header className="ws-header">
        <div className="ws-container ws-header-inner">
          <Link to="/tienda" aria-label="Wheels Sport" className="ws-wordmark" data-testid="shop-logo">
            <b>wh<em>ee</em>ls</b><span>sport.</span>
          </Link>
          <nav className="ws-nav">
            <a href="https://wheelssport.net/es/bicicletas" target="_blank" rel="noreferrer">Bicicletas</a>
            <a href="https://wheelssport.net/es/experiencias" target="_blank" rel="noreferrer">Experiencias</a>
            <a href="https://wheelssport.net/es/contacto" target="_blank" rel="noreferrer">Contacto</a>
            <Link to="/tienda" className="ws-btn" style={{ padding: '10px 20px', fontSize: 13 }} data-testid="shop-nav-cta">Tienda Online</Link>
          </nav>
        </div>
      </header>
      <main className="ws-container" style={{ paddingTop: 56, paddingBottom: 24 }}>{children}</main>
      <footer className="ws-container ws-footer">
        <span>Wheels Sport © {new Date().getFullYear()} · Av. Nicolau Riera Marsá 2, 07400 Puerto de Alcudia</span>
        <span>Bicicletas de ocasión revisadas por nuestro taller</span>
      </footer>
    </div>
  );
}
